import React, { useCallback, useContext } from 'react'; // add {useCallback, useContext}
import { Redirect } from "react-router";
import {Intent} from '@blueprintjs/core'
import {fireApp, AppToaster} from "../../base.js";
import { AuthContext } from "../../Authentication.js";
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {strings} from '../Utils/Constants';

import { Link } from 'react-router-dom'
function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <span>
                {strings.author}
            </span>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
export default function ResetPswd(history) {
    const classes = useStyles();
    const handleReset = useCallback(
        async event => {
            event.preventDefault();
            const { email } = event.target.elements;
            try {
                await fireApp
                    .auth()
                    .sendPasswordResetEmail(email.value).then(function() {
                        history.history.push("/");
                    });
                    // .then(function() {
                    //     AppToaster.show({intent: Intent.SUCCESS, message: "Nové heslo bylo posláno na zadaný email"});
                    // });
            } catch (error) {
                AppToaster.show({intent: Intent.DANGER, message: error.message})
            }
        },
        [history]
    );
    const { currentUser } = useContext(AuthContext);
    if (currentUser) {
        return <Redirect to="/" />;
    }
    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    Obnovení hesla
                </Typography>
                <form onSubmit={handleReset}  className={classes.form} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Zaslat heslo
                    </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link to="/login" variant="body2">
                                Přihlásit
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}